/** Normalize event dates: blank end date means single-day (end = start). */
export function normalizeEventDates(startDate, endDate) {
  const start = String(startDate || "").trim();
  let end = String(endDate || "").trim();
  if (!start) return { startDate: start, endDate: end };
  if (!end) end = start;
  return { startDate: start, endDate: end };
}

export function isSingleDayEvent(startDate, endDate) {
  const { startDate: start, endDate: end } = normalizeEventDates(startDate, endDate);
  return Boolean(start && start === end);
}

/** Human-readable range; omits the end when single-day. */
export function formatEventDateRange(startDate, endDate, { slash = false } = {}) {
  const { startDate: start, endDate: end } = normalizeEventDates(startDate, endDate);
  const fmt = (d) => (slash ? d.replaceAll("-", "/") : d);
  if (!start) return "TBD";
  if (!end || start === end) return fmt(start);
  return `${fmt(start)} — ${fmt(end)}`;
}
